import '../css/blocks.css';

import heroHome from '../../blocks/hero-home/hero-home';
import misattribution from '../../blocks/misattribution/misattribution';
import ourWork from '../../blocks/our-work/our-work';
import workIntro from '../../blocks/work-intro/work-intro';
import workHero from '../../blocks/work-hero/work-hero';
import workLive from '../../blocks/work-live/work-live';
import workListing from '../../blocks/work-listing/work-listing';
import aboutHero from '../../blocks/about-hero/about-hero';
import aboutServices from '../../blocks/about-services/about-services';
import aboutTeam from '../../blocks/about-team/about-team';
import aboutProof from '../../blocks/about-proof/about-proof';
import aboutStory from '../../blocks/about-story/about-story';
import howHero from '../../blocks/how-hero/how-hero';
import howSteps from '../../blocks/how-steps/how-steps';
import howCards from '../../blocks/how-cards/how-cards';
import howEvidence from '../../blocks/how-evidence/how-evidence';
import howClose from '../../blocks/how-close/how-close';
import contact from '../../blocks/contact/contact';
import mediaRow from '../../blocks/media-row/media-row';

document.addEventListener('DOMContentLoaded', function () {
	heroHome();
	misattribution();
	ourWork();
	workIntro();
	workHero();
	workLive();
	workListing();
	aboutHero();
	aboutServices();
	aboutTeam();
	aboutProof();
	aboutStory();
	howHero();
	howSteps();
	howCards();
	howEvidence();
	howClose();
	contact();
	mediaRow();
});
